<template>
    <div v-if="usuario != null" class="col-12 col-md-12 text-justify">
        <div>
            <h4>Información de la cuenta</h4>
            <hr />
            <div class="d-flex row">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12 form-group">
                    <label for="correoElectronicoLogin">Correo electrónico/Login</label>
                    <input type="text" class="form-control input-sm" id="correoElectronicoLogin" placeholder="Ingrese el correo electronico del usuario" v-model="usuario.Email" v-on:keyup="validaQueSeanIdenticosLosCorreosPersonales(true)" />
                    <label v-if="esUnCorreoValido != null && esUnCorreoValido == false" class="colorRojo">El correo electrónico no es valido.</label>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12 form-group">
                    <label for="confirmaCorreoElectronicoLogin">Confirma el correo electrónico/login</label>
                    <input type="text" class="form-control input-sm" id="confirmaCorreoElectronicoLogin" placeholder="Confirme el correo electronico del usuario" v-model="confirmacionEmail" v-on:keyup="validaQueSeanIdenticosLosCorreosPersonales(true)" />
                    <label v-if="sonCorreosIdenticos == false" class="colorRojo">Los correos electrónicos ingresados no son los mismos.</label>
                </div>
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xlg-6 form-group">
                    <label for="puestoJuridico">Puesto jurídico</label>
                    <C005PuestoJuridico v-on:valorParaElPadre="cambiaElPuestoJuridico" :prefijo="catalogo.etiquetaDeHtml" :tipo="catalogo.tipoDeSelect" :idDelInput="'puestoJuridico'" :parametros="{}" :valorDefinido="(usuario.PuestoJuridico != null ? usuario.PuestoJuridico.PuestoJuridicoId : -1)"></C005PuestoJuridico>
                </div>
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xlg-6 form-group">
                    <label for="puestoAdministrativo">Puesto administrativo</label>
                    <C006PuestoAdministrativo v-on:valorParaElPadre="cambiaElPuestoAdministrativo" :prefijo="catalogo.etiquetaDeHtml" :tipo="catalogo.tipoDeSelect" :idDelInput="'puestoAdministrativo'" :parametros="{}" :valorDefinido="(usuario.PuestoAdministrativo != null ? usuario.PuestoAdministrativo.PuestoAdministrativoId : -1)"></C006PuestoAdministrativo>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12 form-group">
                    <label for="institucion">Institución que pertenece</label>
                    <C055Instituciones v-on:valorParaElPadre="cambiaLaInstitucion" :prefijo="catalogo.etiquetaDeHtml" :tipo="catalogo.tipoDeSelect" :idDelInput="'institucion'" :parametros="{ Funcion: funcionId }" :valorDefinido="(usuario.Institucion != null ? usuario.Institucion.InstitucionId : -1)"></C055Instituciones>
                </div>
            </div>
            <br />
            <h4>Información personal</h4>
            <hr />
            <div class="d-flex row">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12 form-group">
                    <label for="nombre">Nombre(s)</label>
                    <input type="text" class="form-control input-sm" id="nombre" placeholder="Ingrese el nombre del usuario" v-model="usuario.Nombre" />
                </div>
                <div class="col-12 col-sm-12 col-md-5 col-lg-5 col-xlg-5 form-group">
                    <label for="apellidoPaterno">Apellido paterno/Primer apellido</label>
                    <input type="text" class="form-control input-sm" id="apellidoPaterno" placeholder="Ingrese el primer apellido del usuario" v-model="usuario.ApellidoPaterno" />
                </div>
                <div class="col-12 col-sm-12 col-md-5 col-lg-5 col-xlg-5 form-group">
                    <label for="apellidoMaterno">Apellido materno/Segundo apellido</label>
                    <input type="text" class="form-control input-sm" id="apellidoMaterno" placeholder="Ingrese el segundo apellido del usuario" v-model="usuario.ApellidoMaterno" />
                </div>
                <div class="col-12 col-sm-12 col-md-2 col-lg-2 col-xlg-2 form-group">
                    <label for="iniciales">Iniciales</label>
                    <input type="text" class="form-control input-sm" id="iniciales" placeholder="Ingrese las iniciales del usuario" v-model="usuario.Iniciales" />
                </div>
                <div class="col-12 col-sm-12 col-md-5 col-lg-5 col-xlg-5 form-group">
                    <label for="curp">CURP</label>
                    <input type="text" class="form-control input-sm" id="curp" placeholder="Ingrese la CURP del usuario (AAAA######AAAAAAN#)" v-model="usuario.Curp" v-mask="'AAAA######AAAAAAN#'" v-on:keyup="usuario.Curp = usuario.Curp.toUpperCase()" />
                </div>
                <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xlg-4 form-group">
                    <label for="tipoSexo">Tipo de sexo</label>
                    <C012TiposSexo v-on:valorParaElPadre="cambiaElTipoSexo" :prefijo="catalogo.etiquetaDeHtml" :tipo="catalogo.tipoDeSelect" :idDelInput="'tipoSexo'" :parametros="{}" :valorDefinido="(usuario.TipoSexo != null ? usuario.TipoSexo.TipoSexoId : -1)"></C012TiposSexo>
                </div>
                <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xlg-3 form-group">
                    <label for="tipoTitulo">Tipo de titulo</label>
                    <C027TiposTitulo v-on:valorParaElPadre="cambiaElTipoTitulo" :prefijo="catalogo.etiquetaDeHtml" :tipo="catalogo.tipoDeSelect" :idDelInput="'tipoTitulo'" :parametros="{}" :valorDefinido="(usuario.TipoTitulo != null ? usuario.TipoTitulo.TipoTituloId : -1)"></C027TiposTitulo>
                </div>
            </div>
            <br />
            <h4>Juzgados donde trabaja</h4>
            <hr />
            <div class="d-flex row">
                <div class="col-12 form-group">
                    <label for="area">Areas</label>
                    <C001Area v-on:valorParaElPadre="cambiaElTipoSexo" :prefijo="catalogo.etiquetaDeHtml" :tipo="catalogo.tipoDeSelect" :idDelInput="'area'" :parametros="{ Activo: true }" :valorDefinido="-1"></C001Area>
                </div>
                <div class="col-12 text-right">
                    <button class="btn btn-primary overwrapDeBotones" id="agregaArea" v-on:click="agregaArea()"><i class="fas fa-plus-circle"></i>&nbsp;&nbsp;Agrega el área</button>
                </div>
                <div v-if="usuario != null && usuario != undefined" class="col-12 table-responsive">
                    <br />
                    <h6>Estos son los juzgados que estan relacionados con la cuenta</h6>
                    <table class="table table-striped table-light table-hover table-bordered table-sm" id="tablaDeUsuarios_table">
                        <thead class="thead-dark text-center">
                            <tr>
                                <th>Nombre</th>
                                <th>¿Trabaja aqui?</th>
                                <th>Eliminar</th>
                            </tr>
                        </thead>
                        <tbody class="text-justify">
                            <tr v-if="usuario.JuzgadosDondeTrabaja.length <= 0" class="text-center" >
                                <td colspan="3">No existen registros con el nombre otorgado</td>
                            </tr>
                            <tr v-else v-for="areaDelUsuario in usuario.AreasDelUsuario" :key="areaDelUsuario.Area.AreaId">
                                <td class="text-left">{{areaDelUsuario.Area.Nombre}}</td>
                                <td class="text-center">
                                    <i v-if="areaDelUsuario.TrabajaAqui == true" class="far fa-check-circle colorVerde"></i>
                                    <a v-else-if="areaDelUsuario.TrabajaAqui == false" title="Activa el area de trabajo"><i class="fas fa-ban colorRojo"></i></a>
                                </td>
                                <td class="text-center">
                                    <a><i class="fas fa-trash"></i></a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <br />
            <h4>Información relacionada con SIAP</h4>
            <hr />
            <div v-if="usuario != null && usuario != undefined" class="d-flex row">
                <div v-if="usuario.Persona != null && usuario.Persona != undefined" class="col-12 colorVerde">
                    <h6><strong>La informacion relacionada a la cuenta es: 
                        {{usuario.Persona.Nombre}}
                        {{(usuario.Persona.ApellidoPaterno != null && usuario.Persona.ApellidoPaterno != "" ? " " + usuario.Persona.ApellidoPaterno : "")}}
                        {{(usuario.Persona.ApellidoMaterno != null && usuario.Persona.ApellidoMaterno != "" ? " " + usuario.Persona.ApellidoMaterno : "")}}
                        con el puesto de {{usuario.Persona.Puesto}}</strong></h6>
                </div>
                <br />
                <br />
                <div class="col-12 table-responsive">
                    <h6>La busqueda de la persona se hace en base a los nombres y apellidos ingresados en la seccion "Información personal". Cada vez que modifiques el nombre, la tabla se vaciara y solo necesitara recargar la información</h6>
                    <div class="text-right">
                        <button class="btn btn-warning overwrapDeBotones" id="recargaSIAP" v-on:click="recargaLaTablaDeSIAP()"><i class="fas fa-redo-alt"></i>&nbsp;&nbsp;Recarga y busca en SIAP</button>
                    </div>
                    <br />
                    <table class="table table-striped table-light table-hover table-bordered table-sm" id="tablaDeUsuarios_table">
                        <thead class="thead-dark text-center">
                            <tr>
                                <th></th>
                                <th>Id</th>
                                <th>Nombre completo</th>
                                <th>Puesto</th>
                            </tr>
                        </thead>
                        <tbody class="text-justify">
                            <tr v-if="personasSIAP.length <= 0" class="text-center" >
                                <td colspan="4">No existen registros con el nombre otorgado</td>
                            </tr>
                            <tr v-else v-for="personaSIAP in personasSIAP" :key="personaSIAP.PersonaId" style="cursor: pointer">
                                <td>
                                    <input type="checkbox" name="personaSeleccionada" :id="'check_persona' + personaSIAP.PersonaId" :checked="usuario.Persona != null && personaSIAP.PersonaId == usuario.Persona.PersonaId" v-on:click="this.usuario.PersonaId_DBSIAP = personaSIAP.PersonaId" />
                                </td>
                                <td class="text-center">{{personaSIAP.PersonaId}}</td>
                                <td>{{personaSIAP.Nombre}}{{(personaSIAP.ApellidoPaterno != "" && personaSIAP.ApellidoPaterno != null ? " " + personaSIAP.ApellidoPaterno : "")}}{{(personaSIAP.ApellidoMaterno != "" && personaSIAP.ApellidoMaterno != null ? " " + personaSIAP.ApellidoMaterno : "")}}</td>
                                <td>{{personaSIAP.Puesto}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <br />
        <div class="text-right">
            <button class="btn btn-danger overwrapDeBotones" id="cancelarYCerrar" v-on:click="FuncionalidadDeCancelado()"><i class="fas fa-times-circle"></i>&nbsp;&nbsp;Cancelar y cerrar</button>
            <button class="btn btn-success overwrapDeBotones" id="guardarUsuario" v-on:click="FuncionalidadDeGuardado()"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar usuario</button>
        </div>
    </div>
</template>

<script>
import enumeraciones from '@/../static/js/enumeraciones'
import catalogos from '@/../static/js/catalogos'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import VueMask from "v-mask";

import C001Area from '@/components/PJ/Catalogos/001Area.vue'
import C005PuestoJuridico from '@/components/PJ/Catalogos/005PuestoJuridico.vue'
import C006PuestoAdministrativo from '@/components/PJ/Catalogos/006PuestoAdministrativo.vue'
import C012TiposSexo from '@/components/PJ/Catalogos/012TiposSexo.vue'
import C027TiposTitulo from '@/components/PJ/Catalogos/027TiposTitulo.vue'
import C055Instituciones from '@/components/SICUS/Comun/Catalogos/055Instituciones.vue'

export default {
    data() {
        return {
            enumeraciones, 
            usuario: null, 
            personasSIAP: [], 
            catalogo: { etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione },
            confirmacionEmail: '', 
            sonCorreosIdenticos: null,
        }
    },
    components: {
        C001Area,
        C005PuestoJuridico,
        C006PuestoAdministrativo, 
        C012TiposSexo,
        C027TiposTitulo,
        C055Instituciones
    },
    props: {
        usuarioId: Number, 
        segundaParteDelAPI: String, 
        funcionId: Number
    }, 
    computed: {
        esUnCorreoValido() {
            if (this.usuario == null) {
                return null;
            }

            if(this.usuario.Email == "" || this.usuario.Email == null || !comun.EsCorreoElectronico(this.usuario.Email, false)) {
                this.usuario.EmailValidado = false;
            } else {
                this.usuario.EmailValidado = true;
            }

            return this.usuario.EmailValidado;
        }
    },
    mounted() {
        this.usuario = null;
        this.BuscaAlUsuario(this.usuarioId)
    },
    methods: {
        VerificaQueExistaUnUsuarioId() {
            if (!this.usuarioId && this.usuarioId > 0) {
                comun.mensajeDeAlerta("No existe un Id de usuario con el que se puoeda realizar la busqueda.<br /><br />Recargue la página y si sigue sucediendo lo mismo, contacte el departamento de Informática.", null, null);
                return false
            }

            return true
        },
        BuscaAlUsuario(usuarioId) {
            if (this.VerificaQueExistaUnUsuarioId()) {
                comun.SeEstaCargandoInformacion(true);

                const parametros = {
                    UsuarioId: this.usuarioId,
                    EsPrueba: this.enumeraciones.EsPrueba
                };

                axios.post(
                    api.conexion + this.segundaParteDelAPI,
                    parametros,
                    comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
                ).then(respuesta => {
                    if(respuesta.data.SiHayError){
                        console.log(respuesta);
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                        this.$store.dispatch('A_ReglasDeRuteo', { aDondeSeRuteaOElError: respuesta.data.Error.MensajeId });
                        this.FuncionalidadDeCancelado();
                    } else {
                        this.usuario = respuesta.data.Usuario;
                        console.log(this.usuario.Persona)
                        this.validaQueSeanIdenticosLosCorreosPersonales(true)
                    }
                    comun.SeEstaCargandoInformacion(false);
                }
                ).catch(excepcion => {
                    console.log(excepcion);
                    comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                    comun.SeEstaCargandoInformacion(false);
                });
            }
        },
        validaQueSeanIdenticosLosCorreosPersonales: function(EsModificacionSobreCampo) {
            if(this.confirmacionEmail != this.usuario.Email) {
                this.sonCorreosIdenticos = false

                if(!EsModificacionSobreCampo) {
                    comun.mensajeDeAlerta("Los correos electrónicos ingresados no son los mismos.<br/>Corrija el error e inténtelo de nuevo.", null, null);
                    return false;
                }
            } else {
                this.sonCorreosIdenticos = true

                if(!EsModificacionSobreCampo) {
                    return true;
                }
            }
        },
        cambiaElPuestoJuridico (datos) {
            if (parseInt(datos.target.value) == -1) {
                return this.usuario.PuestoJuridico = null
            }

            if (this.usuario.PuestoJuridico === undefined || this.usuario.PuestoJuridico === null)
                this.usuario.PuestoJuridico = {}

            if (datos.target.value !== "-1")
                this.usuario.PuestoJuridico.PuestoJuridicoId = parseInt(datos.target.value);
            else
                this.usuario.PuestoJuridico = null;
        },
        cambiaElPuestoAdministrativo (datos) {
            if (parseInt(datos.target.value) == -1) {
                return this.usuario.PuestoAdministrativo = null
            }

            if (this.usuario.PuestoAdministrativo === undefined || this.usuario.PuestoAdministrativo === null)
                this.usuario.PuestoAdministrativo = {}
            
            if (datos.target.value !== "-1")
                this.usuario.PuestoAdministrativo.PuestoAdministrativoId = parseInt(datos.target.value);
            else
                this.usuario.PuestoAdministrativo = null;
        },
        cambiaLaInstitucion (datos) {
            if (parseInt(datos.target.value) == -1) {
                return this.usuario.Institucion = null
            }

            if (this.usuario.Institucion === undefined || this.usuario.Institucion === null)
                this.usuario.Institucion = {}
            
            if (datos.target.value !== "-1")
                this.usuario.Institucion.InstitucionId = parseInt(datos.target.value);
            else
                this.usuario.Institucion = null;
        }, 
        cambiaElTipoSexo (datos) {
            if (parseInt(datos.target.value) == -1) {
                return this.usuario.TipoSexo = null
            }

            if (this.usuario.TipoSexo === undefined || this.usuario.TipoSexo === null)
                this.usuario.TipoSexo = {}
            
            if (datos.target.value !== "-1")
                this.usuario.TipoSexo.TipoSexoId = parseInt(datos.target.value);
            else
                this.usuario.TipoSexo = null;
        },
        cambiaElTipoTitulo (datos) {
            if (parseInt(datos.target.value) == -1) {
                return this.usuario.TipoTitulo = null
            }

            if (this.usuario.TipoTitulo === undefined || this.usuario.TipoTitulo === null)
                this.usuario.TipoTitulo = {}
            
            if (datos.target.value !== "-1")
                this.usuario.TipoTitulo.TipoTituloId = parseInt(datos.target.value);
            else
                this.usuario.TipoTitulo = null;
        },
        verificaQueElNombreCompletoEsteIngresado() {
            if (this.usuario.Nombre == null || this.usuario.Nombre == "") {
                comun.mensajeDeAlerta("No se ha ingresado el nombre del usuario.<br /><br />Ingreselo e inténtelo de nuevo.", null, null);
                return false
            }

            if ((this.usuario.ApellidoPaterno != null && this.usuario.ApellidoPaterno != "") || (this.usuario.ApellidoMaterno != null && this.usuario.ApellidoMaterno != "")) {
                return true
            }

            comun.mensajeDeAlerta("No se ha ingresado al menos un apellido.<br /><br />Ingreselo e inténtelo de nuevo.", null, null);
            return false
        },
        recargaLaTablaDeSIAP() {
            if (this.verificaQueElNombreCompletoEsteIngresado()) {
                comun.SeEstaCargandoInformacion(true);

                const parametros = {
                    Nombre: this.usuario.Nombre, 
                    PrimerApellido: this.usuario.ApellidoPaterno, 
                    SegundoApellido: this.usuario.ApellidoMaterno,
                    Funcion: this.funcionId,
                    EsPrueba: this.enumeraciones.EsPrueba
                };

                axios.post(
                    api.conexion + api.SICUS.funcion.ObtenPersonasDeSIAP,
                    parametros,
                    comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
                ).then(respuesta => {
                    if(respuesta.data.SiHayError){
                        console.log(respuesta);
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                        this.$store.dispatch('A_ReglasDeRuteo', { aDondeSeRuteaOElError: respuesta.data.Error.MensajeId });
                    } else {
                        this.personasSIAP = respuesta.data.Personas
                    }
                    comun.SeEstaCargandoInformacion(false);
                }
                ).catch(excepcion => {
                    console.log(excepcion);
                    comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                    comun.SeEstaCargandoInformacion(false);
                });
            }
        }, 
        FuncionalidadDeCancelado() {
            this.$emit("ejecutaLaFuncionalidadDeCancelado");
        }, 
        validaQueTodoEsteCorrecto() {
            if (!this.validaQueSeanIdenticosLosCorreosPersonales(false)) return false;

            if (!this.esUnCorreoValido) {
                comun.mensajeDeAlerta("El correo electrónico no es valido.<br /><br />Verifiquelo e inténtelo de nuevo.", null, null);
                return false;   
            }
            
            if (!this.verificaQueElNombreCompletoEsteIngresado()) return false;

            return true;
        },
        FuncionalidadDeGuardado() {
            if (this.validaQueTodoEsteCorrecto()) {
                this.$emit("ejecutaLaFuncionalidadDeGuardado", this.usuario)
            }
        }
    }
}
</script>

<style scoped>
    .colorVerde{
        color: green;
    }

    .colorRojo {
        color: red;
    }
</style>


// WEBPACK FOOTER //
// src/components/SICUS/Comun/Usuario.vue